import React from 'react'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'

const PointsPreview = ({points, isCheckout}) => {
    return (
        <Box background="gray.200" padding={{base: isCheckout ? 2 : 3}}>
            <Text fontSize={{base: 'sm'}}
                color="loyaltyT3"
                textAlign="center"
                lineHeight={{base: '18px'}}
                fontWeight={{base: isCheckout ? 'medium' : 'normal'}}>
                <FormattedMessage
                    defaultMessage="You can earn {points} points on this order!"
                    values={{points}}
                    id="cart.loyalty.coupon.points_can_be_earned"
                />
            </Text>
        </Box>
    )
}

PointsPreview.propTypes = {
    points: PropTypes.number,
    isCheckout: PropTypes.bool
}

export default PointsPreview
